(function () {
  "use strict";

  if (window.__toxicStockLoaded) return;
  window.__toxicStockLoaded = true;

  const WIDGET_SELECTOR = ".tsw-widget";

  async function getCart() {
    const res = await fetch("/cart.js", { cache: "no-store" });
    if (!res.ok) throw new Error("Cart fetch failed");
    return res.json();
  }

  function getWidgets() {
    return Array.from(document.querySelectorAll(WIDGET_SELECTOR));
  }

  function getToxicVariantIds() {
    const ids = new Set();
    getWidgets().forEach((widget) => {
      try {
        const products = JSON.parse(widget.dataset.toxicProducts || "[]");
        products.forEach((p) => ids.add(p.variantId));
      } catch {
        /* ignore */
      }
    });
    return ids;
  }

  let refreshing = false;
  let refreshQueued = false;

  async function refreshWidgets() {
    const widgets = getWidgets();
    if (!widgets.length) return;

    const toxicVariantIds = getToxicVariantIds();
    if (!toxicVariantIds.size) return;

    if (refreshing) {
      refreshQueued = true;
      return;
    }
    refreshing = true;

    let cart;
    try {
      cart = await getCart();
    } catch {
      refreshing = false;
      return;
    }

    const cartLines = cart.items || [];

    const toxicAlreadyInCart = cartLines.some((item) => {
      const gid = `gid://shopify/ProductVariant/${item.variant_id}`;
      return toxicVariantIds.has(gid);
    });

    const hasNonToxicItem = cartLines.some((item) => {
      const gid = `gid://shopify/ProductVariant/${item.variant_id}`;
      return !toxicVariantIds.has(gid);
    });

    const visible = !toxicAlreadyInCart && hasNonToxicItem;

    getWidgets().forEach((widget) => {
      widget.style.display = visible ? "block" : "none";
      widget.dataset.toxicInit = "1";
    });

    refreshing = false;
    if (refreshQueued) {
      refreshQueued = false;
      refreshWidgets();
    }
  }

  /**
   * Reintenta el refresh varias veces: el drawer se re-renderiza por AJAX
   * tras el primer add-to-cart y el widget puede no existir aún en el DOM.
   */
  function scheduleRefresh(delays) {
    const times = delays || [0, 200, 500, 900];
    times.forEach((delay) => {
      setTimeout(refreshWidgets, delay);
    });
  }

  function setupCartListeners() {
    [
      "cart:updated",
      "cart:refresh",
      "cart:item-added",
      "line-item:change:end",
      "cart-drawer:open",
    ].forEach((ev) => {
      document.addEventListener(ev, () => scheduleRefresh());
    });

    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const url = String(args[0] || "");
      const isCartMutation =
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear");

      const result = await originalFetch.apply(this, args);
      if (isCartMutation) {
        scheduleRefresh([250, 600, 1100]);
      }
      return result;
    };
  }

  function setupAddButtons() {
    document.addEventListener("click", async (e) => {
      const btn = e.target.closest(".tsw-product__btn[data-variant-id]");
      if (!btn || btn.classList.contains("tsw-loading")) return;

      const widget = btn.closest(WIDGET_SELECTOR);
      if (!widget) return;

      let toxicProducts;
      try {
        toxicProducts = JSON.parse(widget.dataset.toxicProducts || "[]");
      } catch {
        return;
      }

      const variantId = btn.dataset.variantId;
      const product = toxicProducts.find((p) => p.variantId === variantId);
      if (!product) return;

      const numericId = variantId.split("/").pop();

      btn.classList.add("tsw-loading");

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{
              id: Number(numericId),
              quantity: 1,
            }],
          }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || "Cart add failed");
        }

        btn.classList.remove("tsw-loading");
        btn.classList.add("tsw-added");

        const label = btn.querySelector(".tsw-btn-label");
        const plus = btn.querySelector(".tsw-btn-plus");
        if (label) label.textContent = "✓ Añadido";
        if (plus) plus.style.display = "none";

        getWidgets().forEach((w) => {
          w.style.display = "none";
        });

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));

        if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") {
          const updatedCart = await getCart();
          window.Shopify.onCartUpdate(updatedCart);
        }
      } catch {
        btn.classList.remove("tsw-loading");
        btn.classList.add("tsw-error");

        const label = btn.querySelector(".tsw-btn-label");
        if (label) label.textContent = "Error · reintentar";

        setTimeout(() => {
          btn.classList.remove("tsw-error");
          const labelEl = btn.querySelector(".tsw-btn-label");
          const plusEl = btn.querySelector(".tsw-btn-plus");
          if (labelEl) labelEl.textContent = `Añadir · ${btn.dataset.name || ""}`;
          if (plusEl) plusEl.style.display = "";
        }, 2200);
      }
    });
  }

  let mutationTimer;
  function setupMutationObserver() {
    const observer = new MutationObserver(() => {
      if (!document.querySelector(`${WIDGET_SELECTOR}:not([data-toxic-init])`)) return;
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(() => scheduleRefresh([0, 300, 700]), 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bootstrap() {
    scheduleRefresh([0, 100]);
    setupCartListeners();
    setupAddButtons();
    setupMutationObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
})();
